export const DisplayItemsData = [
    {
        id:1,
        forward: "/Veg/Breakfast",
        img: "https://media.istockphoto.com/photos/corn-misal-pav-is-a-special-dish-in-maharashtra-india-the-dish-is-picture-id1292641182?b=1&k=20&m=1292641182&s=170667a&w=0&h=4-3pCvj9cDJm3SmSGqzLOnTPNWSGL4GFcqZZ9lr8epM=",
        title: "Spicy Misal"
    },
    {
        id: 2,
        forward: "/Veg/Starter",
        img: "https://media.istockphoto.com/photos/chilli-paneer-indian-snack-food-picture-id1311491582?b=1&k=20&m=1311491582&s=170667a&w=0&h=TsMv3jRUnX1WQR7xhiouu3AOUYAmgt_fEuch_U3d_wc=",
        title: "Enjoy Paneer chilli"
    },
    {
        id: 3,
        forward: "/Veg/MainCourse",
        img: "https://res.cloudinary.com/mealthy1/image/upload/ar_16:11,c_fill,f_auto,h_600,q_auto:best,w_800/v1549977974/cms_recipe_featured_image/m3czw2wmsijjbwsjpgor.jpg",
        title: "Delicious Paneer Tikka Masala"
    },
    {
        id: 4,
        forward: "/Veg/Rice",
        img: "https://res.cloudinary.com/swiggy/image/upload/f_auto,q_auto,fl_lossy/dyaex0us9hnwzstoades",
        title: "Rice"
    },
    {
        id: 5,
        forward: "/Veg/Noodles",
        img: "https://www.cookwithmanali.com/wp-content/uploads/2020/03/Instant-Pot-Vegetarian-Singapore-Noodles-500x500.jpg",
        title: "Tasty Noodles"
    },
    {
        id: 6,
        forward: "/NonVeg/Breakfast",
        img: "https://www.indianhealthyrecipes.com/wp-content/uploads/2016/07/chicken-sandwich-with-mayo-500x500.jpg",
        title: "Start your day"
    },
    {
        id: 7,
        forward: "/NonVeg/Starter",
        img: "https://upload.wikimedia.org/wikipedia/commons/5/5d/Chicken_65_%28Dish%29.jpg",
        title: "Taste Chicken 65"
    },
    {
        id: 8,
        forward: "/NonVeg/MainCourse",
        img: "https://kfoods.com/images1/newrecipeicon/chicken-handi_10645.jpg",
        title: "Classic Handi"
    },
    {
        id: 9,
        forward: "/NonVeg/Rice",
        img: "https://www.thedeliciouscrescent.com/wp-content/uploads/2019/04/Chicken-Biryani-Square.jpg",
        title: "Biryani is a emotion"
    },
    {
        id: 10,
        forward: "/NonVeg/Tandoori",
        img: "https://media-cdn.greatbritishchefs.com/media/x3ykkboh/img16453.jpg?mode=crop&width=768&height=512&center=0.472,0.4816666666666666666666666667",
        title: "You Need to Eat"
    },
]